import React from 'react';
import { Box, Text, VStack, Circle } from '@chakra-ui/react';
import { ReactComponent as ConfirmIcon } from '../../../../assets/images/icons/ic-confirm-audio-prescription.svg';

function TranscriptionSuccess() {
  return (
    <Box
      position="absolute"
      top="0"
      left="0"
      right="0"
      bottom="0"
      bg="white"
      borderRadius="16px"
      display="flex"
      alignItems="center"
      justifyContent="center"
      zIndex="10"
    >
      <VStack spacing="16px">
        <Circle>
          <ConfirmIcon />
        </Circle>
        <Text fontSize="18px" fontWeight="700" color="#343A40" textAlign="center">
          Transcrição finalizada
        </Text>
      </VStack>
    </Box>
  );
}

export { TranscriptionSuccess };
